import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/UploadChildSkuMaster';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const UploadChildSkuMaster = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Child Sku Master - Upload</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

UploadChildSkuMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(UploadChildSkuMaster);
